import useSWR from "swr";
import { axiosInstance } from "../axiosConfig";
import { FAQResponse } from "../types/FAQ";
import { QueryData } from "../types/QueryData.interface";

const BASE_URL = "/faqs";

const fetcher = async (url: string): Promise<FAQResponse> =>
  axiosInstance.get(url).then((resp) => resp.data);

const useGetFAQ = (): QueryData<FAQResponse> => {
  return useSWR<FAQResponse>(BASE_URL, fetcher);
};

export { useGetFAQ };
